import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "w-main" }
const _hoisted_2 = { class: "w-column-primary" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "w-topbar-aux" }, null, -1)
const _hoisted_4 = { class: "tech-flex" }
const _hoisted_5 = { class: "operational" }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", null, "TICKET NOT FOUND", -1)
const _hoisted_8 = [
  _hoisted_7
]

import TicketCard from '@/components/Workspaces/tickets/_spec/TicketCard.vue';
import { computed, onBeforeMount, onMounted, onUnmounted, reactive, watch } from 'vue';
import { useAppContext } from '@/app/_tech';
import { TicketRmodel } from '@/app.context/workspace/ticket.rmodel';

import TicketSummary from '@/components/Workspaces/tickets/_spec/TicketSummary.vue'

import { ticketUpdateController_Alt } from '@/controllers/workspaces/tickets/_spec/ticket.controller.chat'
import { TicketItemModel } from '@/app.context/workspace/tickets/_spec/Ticket.Item.Model';
import userVueController from '@/components/Workspaces/users/_spec/user.controller.vue'
import { TicketBoardController } from '@/components/Workspaces/tickets/_spec/ticket.controller.elementary.interface';
import {ITicketDto} from '@/io/dto/workspaces/ticket.dto'


export default /*#__PURE__*/_defineComponent({
  __name: 'TicketSubview',
  props: {
    workspace: {},
    ticket: {}
  },
  setup(__props: any) {

const context = useAppContext();

const { user_level } = userVueController(context)

const ticketBoardController = TicketBoardController(context)

const props = __props

const ticket_model = computed(() => data.model.ticket)

const data: { model: TicketItemModel, absense: boolean /* flag that ticket not found*/ } = reactive({ absense: false, model: new TicketItemModel() });

watch(() => context.cursor.workspace, setup);

watch(() => props.ticket, setup);

onMounted(setup);

onUnmounted(() => {

  data.model.storage?.disconnect();
});

function setup() {

  data.absense = false;

  if (context.cursor.workspace === null) return; //have to wait until it will be loaded by upper workspace view

  const workspace = context.cursor.workspace!;

  const n: number = parseInt(props.ticket);

  if (data.model.ticket === null || data.model.ticket!.n != n) {

    const ticket = workspace.ticketOrNull(n)

    if (ticket != null) {

      data.model.set(ticket, context)
    }
    else {

      context.service.ticketOrNull(workspace.Wid(), n).then(f).catch(context.catch);

      // eslint-disable-next-line
      function f(dto: ITicketDto | null) {

        if (dto != null) {

          const ticket = reactive(new TicketRmodel(workspace));

          ticket.setup(dto, workspace);

          data.model.set(ticket, context);
        }
        else data.absense = true; //ticket not found
      }
    }
  }
}

ticketUpdateController_Alt(context, data.model)


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        (ticket_model.value != null)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createVNode(TicketSummary, {
                model: data.model,
                files: _unref(context).storages.files,
                level: _unref(user_level)
              }, null, 8, ["model", "files", "level"]),
              _createElementVNode("div", _hoisted_5, [
                _createVNode(TicketCard, {
                  class: "card-current",
                  ticket: ticket_model.value,
                  level: _unref(user_level),
                  "circled-x": true,
                  onPerson: _cache[0] || (_cache[0] = (person, index) => _unref(ticketBoardController).person(ticket_model.value!, person, index)),
                  onBlock: _cache[1] || (_cache[1] = (b) => _unref(ticketBoardController).block(b)),
                  onX: _cache[2] || (_cache[2] = ($event: any) => (_unref(ticketBoardController).close(ticket_model.value))),
                  onV: _cache[3] || (_cache[3] = ($event: any) => (_unref(ticketBoardController).check(ticket_model.value)))
                }, null, 8, ["ticket", "level"])
              ])
            ], 64))
          : (data.absense)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_8))
            : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})